<template>
  <div class="container-fluid verify-wrapper">
    <div class="verify-container">

      <!-- HEADER -->
      <div class="auth-header">
        <div class="brand">
          <img src="../assets/images/logo/logo.png" alt="TusCFDI" height="32" />
        </div>
        <div class="auth-link">
          <router-link :to="{ name: 'login' }" class="link">
            Inicio
          </router-link>
        </div>
      </div>

      <!-- CONTENT -->
      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-xl-5 col-lg-6 col-md-8 col-12">
          <div v-if="formError" class="alert alert-danger mb-3" role="alert">{{ formError }}</div>

          <!-- COMPONENT -->
          <VerifyStatusCard
            :email="email"
            :status="status"
            :hasSentCode="hasSentCode"
            @verify="verifyAccount"
            @resend="resendCode"
            @dashboard="goToRfcSettings"
            @retry="status = 'pending'"
          />

        </div>
      </div>

      <!-- FOOTER -->
      <div class="auth-footer">
        <div class="footer-links">
          <a href="https://tuscfdis.com/terminos">Términos</a>
          <a href="https://tuscfdis.com/privacidad">Privacidad</a>
        </div>
        <small>© 2026 TusCFDIs.</small>
      </div>

    </div>
  </div>
</template>

<script>
import VerifyStatusCard from '@/components/auth/verifyStatusCard.vue';
import { pushGtmEvent } from '@/services/gtm';
import ws from '@/services/login';
import moment from 'moment';

export default {
  name: 'verify',
  components: {
    VerifyStatusCard
  },
  data() {
    return {
      email: this.$route.query.email || '',
      status: 'pending', // pending | success | error
      hasSentCode: false,
      formError: ''
    };
  },
  mounted() {
    pushGtmEvent('registration_verification_form_view', {
      screen_name: 'verify_account',
      flow: 'email_registration',
    })
  },
  methods: {
    goToRfcSettings() {
      this.$router.push({ name: 'settings', query: { section: 'rfcs' } });
    },
    async verifyAccount(code) {
      this.formError = '';
      this.$loading.show();
      try {

        const res = await ws.verifyAccount({ email: this.email, code: code });
        if (res.type === 'success') {
          this.status = 'success';

          pushGtmEvent('registration_confirmed', {
            screen_name: 'verify_account',
            flow: 'email_registration',
            confirmation_method: 'code',
          })

          const data = res.data
          const token = data.token
          const user  = data.user

          localStorage.setItem('access_token', token)
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('rfcs', JSON.stringify(user.rfcs || []))
          localStorage.setItem('period', moment().format("YYYY-MM"))

          //Cuenta nueva sin RFC, redirigir a agregar RFC
          localStorage.setItem('rfc', "")
          localStorage.setItem('fiscal_name', "")

          this.redirectTimer = setTimeout(() => {
            this.goToRfcSettings()
          }, 20000)
        } else {
          this.status = 'error'
        }

      } catch (e) {
        this.formError = 'Error al verificar la cuenta'
      } finally {
        this.$loading.hide();
      }
    },
    async resendCode() {
      this.formError = '';
      this.$loading.show();
      try {

       const res = await ws.sendVerifyCode({ email: this.email });
        if (res.type === 'success') {
          this.hasSentCode = true;
          this.$toast.success('Código reenviado correctamente')
        } else {
          this.formError = 'Error al reenviar el código'
        }

      } catch (e) {
        this.formError = 'Error al reenviar el código'
      } finally {
        this.$loading.hide();
      }
    }
  }
};
</script>
